import { render, staticRenderFns } from "./btnClick.vue?vue&type=template&id=6a334d91&scoped=true"
import script from "./btnClick.vue?vue&type=script&lang=js"
export * from "./btnClick.vue?vue&type=script&lang=js"
import style0 from "./btnClick.vue?vue&type=style&index=0&id=6a334d91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a334d91",
  null
  
)

export default component.exports